
import { debounce } from './lib/debounce';
import {serializeFormAsObject} from './helpers';

/**
 * @experiment GW 4.4 Change button based on Demandbase industry segment
 */

import { createSplitTest } from "./lib/split-test.js";

let demandbaseTimeout = false;

// Set a timeout for Demandbase callback. If DB doesn't fire within 2.5s,
// automatically show default and bypass test. 
setTimeout(() => {
  if (demandbaseTimeout === false) {
    displayTrialStartForm();
    demandbaseTimeout = true;
  }
}, 2500)

/////////////////////////////////////////////////////////////////////////////////////
// Information defined in Split
// https://app.split.io/org/.../ws/.../splits/

// The literal "split" name.
// FIXME(leo): Replace with the correct id
const experimentId = "gw_4_4_demandbase_buttons";

// The literal variant treatment name.
// Split defaults to "on" in teal green
const variant = "variant";

// The control treatment is not used in this script.
// Leaving it as a reference of the treatment name
// const controlTreatment = "existing";

////////////////////////////////////////////////////////////////////////////////
// Information defined in the page

/**
* Callback to modify the DOM based on which treatment was selected.
*
* Since the treatment key can be set through the url query-string (in addition
* to split's rollout-plan) and the value might not be valid, it needs to fail
* gracefully in those cases.
*
* @arg {string} variationId
*/
function setViewTreatment(variationId) {
  if (variationId === variant) {
    displayDemandbaseButton();
  } else {
    displayTrialStartForm();
  }
}

function displayDemandbaseButton() {
  document.getElementById("contact-sales")?.classList.remove("hidden");

}

function displayTrialStartForm() {
  document.getElementById("abtest-trial-form")?.classList.remove("hidden");

}


/**
* Callback to modify the view when the test cannot be started.
* e.g.: Segment or Split code fails to load.
*
* Note: This function is required but can be a no-op (do nothing) if the
* default view is the DOM as initially loaded.
* But since this causes a flash if a variant is selected it is often preferable
* to default to an empty element and explicitly set it.
* Usually the flash between no content -> content is less jarring to a user
* than from one treatment to another
*/
function setDefaultViewTreatment() {}

function setUpDBObserver() {
  // Demandbase will create a form on the page when data from Demandbase is returned.
  const form = /** @type {HTMLFormElement} */(document.getElementById('email-form'));
  if (form) {
    const observer = new MutationObserver(debounce(demandbaseFormMutationHandler(form), 1499));
    observer.observe(form, { attributes: true, childList: true, subtree: false });
  }
}

/**
 * @arg {HTMLFormElement} form
 * @return {() => void}
 */
function demandbaseFormMutationHandler(form) {
  // Callback function to execute when mutations are observed
  return function onMutation(/*mutationsList, observer*/) {
    var formData = serializeFormAsObject(form);
    if (demandbaseTimeout === false) {
      if (formData["DemandBase_Employee_Range__c"] === "Mid-Market" || formData["DemandBase_Employee_Range__c"] === "Enterprise") {
        createSplitTest(splitTestInit);
        demandbaseTimeout = true;
      } else {
        displayTrialStartForm();
      }
    }
  };

}


////////////////////////////////////////////////////////////////////////////////
// Split test constructor

/** @type {import("./lib/split-test.js").SplitTestInit} */
const splitTestInit = {
  experimentId,
  // splitAuthKey: Optional. Useful to override while developing.
  //               Defaults to `defaultSplitAuthKey`.
  setViewTreatment,
  setDefaultViewTreatment
};

setUpDBObserver();




